<template>
  <el-dialog title="预览" :visible.sync="currentValue" :custom-class="show ? 'reviewDialogStylePage' : 'reviewDialogStylePage reviewDialogStylePage-padding'" top="0" append-to-body fullscreen @open="open">
    <template>
      <Tree v-if="list.length > 0" :select="select" :isReviews="true" :list="list"></Tree>
      <Reviews :html="reviewHtml"></Reviews>
      <div class="check-tip" v-if="show">
        <span>此为预览，仅你自己可见，</span>
        <span @click="iSee">知道了</span>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import Reviews from '../reviews'
import Tree from '@/views/helpPage/tree'
import bus from '@/bus'
import api from '@/services/api/help/help'
import {
  Storage
} from '@/utils/utils';
export default {
  props: ['value', 'html', 'id'],
  components: {
    Reviews,
    Tree
  },
  data() {
    return {
      reviewHtml: '',
      list: [],
      select: -1,
      show: false
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
  },
  created() {
    this.show = !Storage.get('isHelpEditReviews')
    bus.$on('editReviewClick', res => {
      if(Number(res.id) === this.id) {
        this.reviewHtml = this.html
        this.select = Number(this.id || -1)
      } else {
        api.documentRed({id: res.id}).then(result => {
          this.select = Number(result.id || -1)
          this.reviewHtml = result.document_content
        })
      }
    })
  },
  methods: {
    open() {
      this.reviewHtml = this.html
      this.select = Number(this.id || -1)
      this.init()
    },
    async init() {
      let result =  await api.documentDraftsIndex({per_page: 999, page: 1, pid: 0, level: 2})
      this.list = result.data
    },
    iSee() {
      this.show = false
      Storage.set('isHelpEditReviews', true)
    }
  }
}
</script>
<style lang="scss">
.reviewDialogStylePage {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
  height: auto;
  position: relative;
  border-radius: 0;
  .el-dialog__header {
    padding: 0 22px;
    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.16);
    height: 54px;
    display: flex;
    justify-content: space-between;
  }
  .el-dialog__header {
    border-bottom: 1px solid rgba(32,32,32,0.08);
    .el-dialog__title {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 18px;
    }
  }
  .el-dialog__body {
    height: 0;
    flex: 1;
    font-size: initial;
    padding-top: 54px;
    display: flex;
  }
  .el-dialog__headerbtn {
    top: 16px;
  }
  .help-reviews {
    width: 0;
    flex: 1;
  }
  .check-tip {
    height: 54px;
    background: rgba(32,32,32,0.04);
    position: absolute;
    left: 0;
    right: 0;
    top: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 14px;
      font-weight: 400;
    }
    span:last-child {
      color: #2682FF;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.reviewDialogStylePage-padding {
  .el-dialog__body {
    padding: 0;
  }
}
</style>
